(() => {
  if (customElements.get('athos-recommendations')) {
    return;
  }

  class AthosRecommendations extends HTMLElement {
    static INIT_DELAY = 10;

    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.source = this.dataset.source;
      this.abortController = new AbortController();
    }

    connectedCallback() {
      this.athosReadyInterval = setInterval(() => {
        if (typeof athos !== 'undefined') {
          clearInterval(this.athosReadyInterval);
          this.initAthosRecommendations();
          return;
        }

        if (!window.athosVariables?.siteId) {
          clearInterval(this.athosReadyInterval);
        }
      }, AthosRecommendations.INIT_DELAY);
    }

    disconnectedCallback() {
      clearInterval(this.athosReadyInterval);
      this.abortController.abort();

      if (this.slider) {
        this.slider.destroy();
      }
    }

    initAthosRecommendations() {
      let productIds = Array.isArray(this.dataset.productIds)
        ? this.dataset.productIds
        : JSON.parse(this.dataset.productIds || '[]');

      this.controllerSettings = {
        id: 'personalized-recommendations',
        tag: this.dataset.tag || 'recommendations',
        limit: Number(this.dataset.limit) || 20,
        globals: {
          products: productIds
        }
      }

      this.controller = athos.initController('recommendations', this.controllerSettings);

      this.controller.init();

      this.controller.search().then(async () => {
        const results = [...this.controller.store.results];

        if (results.length === 0) {
          return;
        }

        const displayed = await this.renderProducts(results);

        if (displayed.length === 0) {
          return;
        }

        const impressionData = displayed.map((product, index) => ({
          type: 'product',
          position: index + 1,
          uid: product.mappings?.core?.uid || product.id || '',
          sku: product.mappings?.core?.sku || ''
        }));

        this.controller.tracker.events.recommendations.impression({
          data: {
            tag: this.controller.store.profile.tag,
            responseId: displayed[0].responseId,
            results: impressionData,
            banners: []
          }
        });

        this.classList.remove('hidden');
      });
    }

    async renderProducts(data) {
      const productHandles = data.map(product => this.getHandle(product));

      const productCards = await athos.fetchProducts(productHandles);

      const slidesContainer = this.querySelector('[data-slides-wrapper]');
      const templateSlide = this.querySelector('#product-slide-template');

      if (!slidesContainer || !templateSlide) {
        return [];
      }

      const slots = this.pairCardsToResults(productCards, data).slice(0, this.controllerSettings.limit);

      slidesContainer.replaceChildren();

      slots.forEach(({ card, product }) => {
        const slide = templateSlide.content.cloneNode(true);

        slide.querySelector('.mb-4').appendChild(card);

        slidesContainer.appendChild(slide);

        const productLink = card.querySelector('a');

        productLink?.addEventListener('click', (event) => {
          this.controller.track.product.clickThrough(event, product);
        }, { signal: this.abortController.signal });
      });

      this.initSlider();

      return slots.map(slot => slot.product);
    }

    getHandle(product) {
      const parts = product.mappings.core.url.split('/');

      return parts[parts.length - 1].split('?')[0];
    }

    pairCardsToResults(cards, data) {
      const slots = [];
      let resultIndex = 0;

      cards.forEach(card => {
        const cardHandle = card.dataset.productHandle;

        while (cardHandle && resultIndex < data.length && this.getHandle(data[resultIndex]) !== cardHandle) {
          resultIndex++;
        }

        if (resultIndex < data.length) {
          slots.push({ card, product: data[resultIndex] });

          resultIndex++;
        }
      });

      return slots;
    }

    initSlider() {
      if (!this.querySelector('[data-product-carousel] .swiper')) return;

      this.options = {
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 4
          }
        },
        navigation: {
          prevEl: this.querySelector('.swiper-button-prev'),
          nextEl: this.querySelector('.swiper-button-next'),
        },
        scrollbar: {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true
        }
      };

      this.slider = new Swiper(
        this.querySelector('[data-product-carousel] .swiper'),
        this.options,
      );
    }
  }

  customElements.define('athos-recommendations', AthosRecommendations);
})();
